import axios from 'axios';
import { ConstructionFeeModel } from 'app/edozvola/cases/construction-fee/model/construction-fee.model';

export const getConstructionFee = async (caseUuid: string): Promise<ConstructionFeeModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/${caseUuid}/construction-fee`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const saveConstructionFee = async (caseUuid: string, constructionFee: ConstructionFeeModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/cases/${caseUuid}/construction-fee`, constructionFee)
      .then(result => {resolve(result.data);})
      .catch(error => {reject(error.response.data.detail);});
  });
};
